<script setup lang="ts">
// TODO: support variants, like buttonVariants
</script>

<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" class="stroke" xmlns="http://www.w3.org/2000/svg">
        <g id="Icons">
            <g id="Vector">
                <path d="M10 7L8 9L6 7" fill="" />
                <path
                    d="M10 7L8 9L6 7H10Z"
                    stroke=""
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
        </g>
    </svg>
</template>

<style>
:disabled .stroke {
    stroke: var(--color-gray-300);
}

.stroke {
    /* --icon-primary, not the blue-500 primitive: light resolves to the same
       blue-500, dark to the blue-200 accent (blue-500 was near-invisible on
       dark input surfaces). */
    stroke: var(--icon-primary);
}
</style>
